// export const URL = 'http://192.168.0.22:8086/system';
// export const URL = "https://data.elitego.cn/api/system";
// export const URL = "http://192.168.0.17:8086/system";
export const URL = "http://192.168.1.242:8086/system";
// export const URL = "http://192.168.1.4:9506/system";
